import type { ISocialOffer } from "@bbj-types/offer";
import { useCallback } from "react";
import { axios } from "../axios";
import type { TSocialOfferCreationOrEdition } from "./types";

export const useUpdateSocialOffer = () => {
  const [state, execute, cancel] = axios<ISocialOffer, TSocialOfferCreationOrEdition, unknown>(
    {
      method: "put",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (socialOffer: TSocialOfferCreationOrEdition & { offerId: string }) => {
      const { offerId, ...rest } = socialOffer;

      return execute({
        url: `/offers/social/${offerId}`,
        data: rest,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
